import { render, staticRenderFns } from "./tagPanel.vue?vue&type=template&id=0c50e9dc&scoped=true&"
import script from "./tagPanel.vue?vue&type=script&lang=js&"
export * from "./tagPanel.vue?vue&type=script&lang=js&"
import style0 from "./tagPanel.vue?vue&type=style&index=0&id=0c50e9dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50e9dc",
  null
  
)

export default component.exports